// ** React Imports
import { useEffect, useState, useRef } from 'react'

// ** Custom Components

// ** Third Party Components
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Bell, Check, MoreVertical, Settings } from 'react-feather'
import { Badge, DropdownMenu, DropdownItem, DropdownToggle, UncontrolledDropdown, Dropdown } from 'reactstrap'
import { Link, useHistory } from 'react-router-dom'

import useJwt from "../../../../auth/jwt/useJwt"
import {initialUser} from "../../../../redux/authentication"
import { ToastCustom } from '../../../../utility/toast/Toast'

// import notiv from '../../../../assets/sounds/notif.wav'
import NotificationItem from '../../../../components/notificationItem/NotificationItem'
import { trans } from '../../../../configs/i18n'

let totalPage = 1

const LIMIT = 25

const NotificationDropdown = () => {
  const [notifications, setNotifications] = useState([])
  const notificationsRef = useRef(notifications)
  const [notificationCount, setNotificationCount] = useState(0)

  const [page, setPage] = useState(1)
  const [open, setOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const user = initialUser().user


  const history = useHistory()

  // const audio = new Audio(notiv)

  useEffect(() => {
    setIsLoading(true)
    useJwt.getNotifications(page, LIMIT).then((response) => {
      setNotificationCount(response?.data?.countUserNotReadNotifications)
      totalPage = totalPage = Math.ceil(response?.data?.pagination?.total / LIMIT)
      setNotifications(notifications.concat(response?.data?.data))

      setIsLoading(false)
      let hubUrl = response.headers.link.match(/<([^>]+)>;\s+rel=(?:mercure|"[^"]*mercure[^"]*")/)[1]
      const hub = new URL(hubUrl, window.origin)
      hub.searchParams.append('authorization', response.headers.mercureauthorization)
      hub.searchParams.append('topic', `/notifications/${user.id}`)

      const eventSource = new EventSource(hub, {
        withCredentials: true,
        heartbeatTimeout: 180000
      })

      eventSource.onmessage = (event) => {
        const eventData = JSON.parse(event.data)
        const notificationsData = eventData.data
        if (eventData.event === 'notification_add') {
          let temp = notificationsRef.current.filter(data => {
            return data.id === notificationsData.id
          })
          if (temp.length === 0) {
            setNotifications((prev) => [notificationsData].concat(prev))
            setNotificationCount((prev) => prev + 1)

            ToastCustom(<NotificationItem toast={true} item={notificationsData}/>, {
              position: "bottom-right"
            })
            // audio.play().catch()
          }

        } else if (eventData.event === 'notification_remove') {
          setNotificationCount((prev) => prev - 1)
          setNotifications((prev) => prev.filter(item => item.id !== notificationsData.id))
        }
      }

      eventSource.onerror = (event) => {
        // eslint-disable-next-line no-console
        console.log(event)
      }
      eventSource.onopen = () => {
      }
    })
  }, [])

  useEffect(() => {
    notificationsRef.current = notifications
  }, [notifications])


  const readAll = () => {
    useJwt.setAsReadAllNotifications().then(() => {
      history.go()
    })
  }

  const handleScroll = async () => {
    setIsLoading(true)
    if (!isLoading) {
      if (page === totalPage) {
        return
      }
      await useJwt.getNotifications(page + 1, LIMIT).then((response) => {
        totalPage = totalPage = Math.ceil(response?.data?.pagination?.total / LIMIT)
        setNotifications(notifications.concat(response?.data?.data))
      })
      setPage(page + 1)
      setIsLoading(false)
    }
  }


  return (
    <Dropdown isOpen={open} toggle={() => setOpen(!open)} tag='li' className='dropdown-notification nav-item me-25'>
      <DropdownToggle tag='a' className='nav-link'>
        <Bell size={21} />
        {notificationCount > 0 &&
          <Badge pill color='danger' className='badge-up'>
            {notificationCount}
          </Badge>
        }
      </DropdownToggle>
      <DropdownMenu end tag='ul' className='dropdown-menu-media mt-0'>
        <li className='dropdown-menu-header'>
          <DropdownItem className='d-flex' tag='div' header>
            <h4 className='notification-type mb-0 me-auto'>{trans('notifications.title')}</h4>
            <UncontrolledDropdown>
              <DropdownToggle tag='a' className='nav-link'>
                <MoreVertical size='18' />
              </DropdownToggle>
              <DropdownMenu end>
                <DropdownItem className='cursor-pointer' href={'/'} onClick={readAll}>
                  <Check size={14} className='me-50' />
                  <span className='align-middle'>{trans('notifications.readAll')}</span>
                </DropdownItem>
                <DropdownItem className='cursor-pointer' onClick={() => { setOpen(false) }} tag={Link} to='/user/settings?tab=5'>
                  <Settings size={14} className='me-50' />
                  <span className='align-middle'>{trans('notifications.settings')}</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </DropdownItem>
        </li>
        {open && <PerfectScrollbar
          onYReachEnd={handleScroll}
          component='li'
          className='media-list scrollable-container'
          options={{
            wheelPropagation: false
          }}
        >
          {notifications.map((item, index) => {
            return <NotificationItem key={index} item={item} />
          })}

          {notifications.length === 0 && <h3 className='px-3 p-1'>{trans("notifications.emptyList")}</h3>}
        </PerfectScrollbar>}
      </DropdownMenu>
    </Dropdown>
  )
}

export default NotificationDropdown
